import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const isLight = theme === "light";

  return (
    <button
      type="button"
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-line bg-surface text-ink shadow-sm transition-transform duration-200 hover:-translate-y-0.5 ${className}`}
      onClick={toggleTheme}
      aria-label={`Switch to ${isLight ? "dark" : "light"} mode`}
    >
      <span
        aria-hidden="true"
        className="relative flex h-6 w-6 items-center justify-center"
      >
        {isLight ? (
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-none stroke-current text-ink"
            strokeWidth="1.8"
          >
            <path
              d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5 fill-[var(--color-accent)] stroke-[var(--color-accent)]"
            strokeWidth="1.5"
          >
            <circle cx="12" cy="12" r="4.25" />
            <path
              d="M12 1.75v2.5M12 19.75v2.5M22.25 12h-2.5M4.25 12h-2.5M19.25 4.75l-1.8 1.8M6.55 17.45l-1.8 1.8M19.25 19.25l-1.8-1.8M6.55 6.55l-1.8-1.8"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
